import { render, staticRenderFns } from "./EditPupil.vue?vue&type=template&id=1091d270&scoped=true&"
import script from "./EditPupil.vue?vue&type=script&lang=js&"
export * from "./EditPupil.vue?vue&type=script&lang=js&"
import style0 from "./EditPupil.vue?vue&type=style&index=0&id=1091d270&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1091d270",
  null
  
)

export default component.exports